import { Route } from 'react-router-dom'
import RequireRoles from '../components/RequireRoles'

/**
 * Turn the route table into <Route> elements. A route with `roles` renders
 * through RequireRoles, so the roles in routes.js are enforced, not just
 * used to hide menu items.
 */
const getRenderedRoutes = (routes = []) =>
    routes.map(({ path, element, roles, routes: children = [] }) => (
        <Route
            key={path}
            path={path}
            element={
                roles?.length ? (
                    <RequireRoles roles={roles}>{element}</RequireRoles>
                ) : (
                    element
                )
            }
        >
            {getRenderedRoutes(children)}
        </Route>
    ))

export default getRenderedRoutes
